// Instruments a jazz improvisation student is likely to play. `key` is the
// transposition key their written music is in (matches the C/Bb/Eb
// convention already used for song transposition, see lib/transposeKey.js).
// `clef` is which clef that instrument's part is written in — 'g' (treble)
// for everything here except the low-register instruments, which read 'f'
// (bass) clef.
export const INSTRUMENTS = [
  { name: 'Piano', key: 'C', clef: 'g' },
  { name: 'Guitar', key: 'C', clef: 'g' },
  { name: 'Bass', key: 'C', clef: 'f' },
  { name: 'Trombone', key: 'C', clef: 'f' },
  { name: 'Flute', key: 'C', clef: 'g' },
  { name: 'Vibraphone', key: 'C', clef: 'g' },
  { name: 'Voice', key: 'C', clef: 'g' },
  { name: 'Trumpet', key: 'Bb', clef: 'g' },
  { name: 'Tenor Saxophone', key: 'Bb', clef: 'g' },
  { name: 'Soprano Saxophone', key: 'Bb', clef: 'g' },
  { name: 'Clarinet', key: 'Bb', clef: 'g' },
  { name: 'Alto Saxophone', key: 'Eb', clef: 'g' },
  { name: 'Baritone Saxophone', key: 'Eb', clef: 'g' },
];

export const INSTRUMENTS_BY_KEY = INSTRUMENTS.reduce((byKey, instrument) => {
  (byKey[instrument.key] ??= []).push(instrument);
  return byKey;
}, {});

export const INSTRUMENT_BY_NAME = Object.fromEntries(
  INSTRUMENTS.map(instrument => [instrument.name, instrument])
);

// No dedicated icon exists for every instrument in the free FontAwesome set
// (or with reliable font support in Unicode), so instruments without a solid
// match (Trombone, Clarinet) fall back to a generic note rather than reusing
// a visually wrong specific instrument (e.g. saxophone for clarinet).
// A dedicated trombone emoji (🪊, U+1FA8A) exists as of Emoji 17.0 but has
// poor font support in practice — falls back to tofu on many systems.
export const INSTRUMENT_ICON_BY_NAME = {
  Piano: '🎹',
  Guitar: '🎸',
  Bass: '🎸',
  Trombone: '🎵',
  Flute: '🪈',
  Vibraphone: '🎹',
  Voice: '🎤',
  Trumpet: '🎺',
  'Tenor Saxophone': '🎷',
  'Soprano Saxophone': '🎷',
  Clarinet: '🎵',
  'Alto Saxophone': '🎷',
  'Baritone Saxophone': '🎷',
};
